$(function () {
  const $doc = $(document);
  let stlHandlersAttached = false;

  function dispatchScrollLock() {
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
  }
  function dispatchScrollUnlock() {
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  }

  function modalClose($dialog) {
    if (!$dialog || !$dialog.length) return;
    if (!$dialog.is('[open]')) return; // already closed
    $dialog.removeAttr('open').attr('inert', '');
    dispatchScrollUnlock();

    // If no dialogs left, remove global handlers (next tick to avoid races)
    setTimeout(() => {
      if ($('.stl-dialog[open]').length === 0) {
        detachGlobalStlHandlers();
      }
    }, 0);
  }

  function openDrawer($btn) {
    if (!$btn || !$btn.length) return;
    const trigger = $btn.data('stl-dialog-trigger');
    const $dialog = $(`.stl-dialog[data-stl-dialog="${trigger}"]`);
    if (!$dialog.length) return;
    if ($dialog.is('[open]')) return; // already open

    $dialog.attr('open', true).removeAttr('inert');
    // dispatchScrollLock();

    // Resize slider after visible (slightly delayed)
    setTimeout(() => {
      const stlProductList = $dialog.find('.shopTheLook__similar__wrapper slider-component')[0];
      stlProductList?.flkty?.resize();
    }, 50);

    // Attach global handlers in next tick so the original opener click doesn't close it immediately
    setTimeout(() => {
      attachGlobalStlHandlers();
    }, 0);

    // DEBUG: uncomment to verify open runs
    // console.debug('stl:opened', trigger);
  }

  function onDocumentClickClose(e) {
    const $openDialogs = $('.stl-dialog[open]');
    if ($openDialogs.length === 0) return;

    // Use topmost open dialog (last in DOM)
    const $top = $($openDialogs.get($openDialogs.length - 1));
    // If click occurred inside the dialog, do nothing
    if ($top[0].contains(e.target)) return;

    modalClose($top);
  }

  function onDocumentKeydown(e) {
    if (e.key === 'Escape' || e.code === 'Escape') {
      const $open = $('.stl-dialog[open]');
      if ($open.length) {
        e.preventDefault();
        modalClose($($open.get($open.length - 1)));
      }
    }
  }

  function attachGlobalStlHandlers() {
    if (stlHandlersAttached) return;
    stlHandlersAttached = true;
    $(document).on('click.stl', onDocumentClickClose);
    $(document).on('keydown.stl', onDocumentKeydown);
  }

  function detachGlobalStlHandlers() {
    if (!stlHandlersAttached) return;
    stlHandlersAttached = false;
    // remove all handlers in our namespace
    $(document).off('.stl');
  }

  // Delegated openers (no trigger('click') to avoid recursion)
  $doc.on('click', '.frame__item', function () {
    const $btn = $(this).closest('.brick__block').find('.shop-the-look-drawer-btn').first();
    if ($btn.length) openDrawer($btn);
  });

  $doc.on('click', '.shop-the-look-drawer-btn', function (e) {
    openDrawer($(this));
  });

  // Close button inside dialog (stopPropagation to avoid extra handling)
  $doc.on('click', '.stl-dialog .drawer__close', function (e) {
    e.stopPropagation();
    modalClose($(this).closest('.stl-dialog'));
  });

});
